import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { LayerContextProvider, layers, Modal, SlideFromTop } from "@activecollab/components";
import classNames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { FETCH_EXPENSES_SUCCESS } from "~/store/action_types";
import { fetchParentExpenses } from "~/store/actions/actions.expenses";
import { ExpenseModalContent } from "./ExpenseModalContent";
import usePagination from "../Hooks/usePagination";

export const ExpenseModalContainer = ({ children, open, onClose, className, parentType, parentId, projectId }) => {
  const dispatch = useDispatch();
  const [headers, setHeaders] = useStateWithCallbackLazy({});
  const [isLoading, setIsLoading] = useState(true);
  const pagination = usePagination(headers);

  useEffect(() => {
    if (parentType && parentId) {
      dispatch(fetchParentExpenses(parentType, parentId, projectId)).then((action) => {
        if (action.type === FETCH_EXPENSES_SUCCESS) {
          setHeaders(action.responseHeaders ? action.responseHeaders : {}, () => {
            setIsLoading(false);
          });
        }
      });
    }
  }, [dispatch, parentId, parentType, projectId, setHeaders]);

  const handleAction = useCallback(
    (action) => {
      if (action.type === FETCH_EXPENSES_SUCCESS) {
        setHeaders(action.responseHeaders ? action.responseHeaders : {}, () => {
          setIsLoading(false);
        });
      }
    },
    [setHeaders]
  );

  const isFetchingNextPage = isLoading && pagination.cursor;

  const handleLoadMore = useCallback(async () => {
    if (pagination.cursor && !isLoading) {
      setIsLoading(true);

      const action = await dispatch(
        fetchParentExpenses(parentType, parentId, projectId, {
          cursor: pagination.cursor,
        })
      );
      handleAction(action);
    }
  }, [pagination.cursor, isLoading, dispatch, parentType, parentId, projectId, handleAction]);

  const cursorDate = pagination.cursor ? moment.utc(pagination.cursor).unix() : undefined;

  return (
    <LayerContextProvider value={{ zIndex: layers.skyscraper }}>
      <Modal
        open={open}
        onClose={onClose}
      >
        <SlideFromTop in={open}>
          <div className={classNames("expense_modal_wrapper expense_form_modal_wrapper", className)}>
            <ExpenseModalContent
              loadingNext={isFetchingNextPage}
              showLimitedAccess={!pagination?.cursor}
              onFetchMore={handleLoadMore}
              cursorDate={cursorDate}
            >
              {children}
            </ExpenseModalContent>
          </div>
        </SlideFromTop>
      </Modal>
    </LayerContextProvider>
  );
};

ExpenseModalContainer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  parentType: PropTypes.string,
  parentId: PropTypes.number,
  projectId: PropTypes.number,
};
